
import { Component, Input, NgZone, ElementRef } from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map'
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { httpService } from '../service/servicio'
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { Carga } from '../datos/carga'
import * as jsPDF from 'jspdf'


@Component({
  selector: 'app-cargas-operador',
  templateUrl: './cargas-operador.component.html',
  styleUrls: ['./cargas-operador.component.css']
})
export class CargasOperadorComponent  {
  lotes: any;
  idLote: any;
  loteActual: any;
  valorTeclado: string = '';
  esWizard: boolean = false;
  articuloActual: any;
  contador: any;
  contadorActual: any;
  oldContador: any;
  maquinaActual: any;
  showRed: number = 0;

        constructor (public http: httpService,  public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

            this.toastr.setRootViewContainerRef(vcr);
             ("en cargas-..");
            this.loaded = false;
            this.descargarCargas();

          };

          misCargas:any;
          uploaded = {
            Status:0,
            Text:''

          }

          public fInicio:string = this.hoy();
          public fFinal:string = this.hoy();

          @Input() cargas: any = [];
          @Input() maquinas: any = [];
          @Input() mCargas:any = [];
          @Input() articulos:any = [];


          titulocargas:string =  '';
          titulolinea:string = '';
          titulomostrarLineas:string ='';
          cargasSearch: string ='';
          maquinaSearch:string = '';
          articuloSearch:string = '';
          place:string = 'Buscar por Cliente';
          sort: string = 'Cliente';
          mostrarDatosCargas:boolean = false;
          mostrarDatosLineas:boolean = false;
          mostrarLineas:boolean = false;
          mostrarCargas: boolean = true;
          mostrarTeclado: boolean = false;
          mostrarTecladoLote: boolean = false;
          mostrarTecladoArticulo: boolean = false;
          mostrarTecladoCarga: boolean = false;
          loaded:boolean = false;
          sum:number = 0.0;
          crearNueva:boolean=false;

          oldMaquina:string='0';
          oldFecha:string=this.hoy();
          IdMaquina:string = '0';
          Fecha:string=this.hoy();

          controlHoras() {
            window.open('https://controlhorario.vendingalgeciras.es', '_blank')
          }

          visitas() {
            this.http.sw.mostrarCargasOperador = false;
            this.http.sw.mostrarVisitas = true;
          }


          wizard() {
            this.esWizard = true;
            this.mostrarTecladoArticulo = true;
          }



          orden(n) {
            if (n == 1) { this.sort='Id'; this.place='Buscar por Id' };
            if (n == 2) { this.sort='Cliente'; this.place='Buscar por Cliente' };
            if (n == 3) { this.sort='Posicion'; this.place='Buscar por Posicion' };
          }

          quitarfiltro(tipo: Number) {
            this.cargasSearch = '';
           }

          hoy() {

              let today = new Date();
              let dd = today.getDate().toString();
              let mm = (today.getMonth() + 1).toString();
              let yyyy:string;


              if(today.getDate() < 10) {

                dd = '0'+ dd;
              }

              if (today.getMonth() < 9) {
                mm = '0'+ mm;
              }

              yyyy = today.getFullYear().toString();

              let fecha = yyyy + '-' + mm + '-' + dd;

              return  fecha;

           }


          filtro() {

            return this.cargas.filter((carga) => {
              if (this.sort == 'Id')
                 return carga.Id.toLowerCase().indexOf(this.cargasSearch.toLowerCase()) != -1;
              if (this.sort == 'Cliente')
                 return carga.Cliente.toLowerCase().indexOf(this.cargasSearch.toLowerCase()) != -1;
              if (this.sort == 'Posicion')
                 return carga.Posicion.toLowerCase().indexOf(this.cargasSearch.toLowerCase()) != -1;

             });
            }



          filtromaquina() {
            this.sum = 0;
            return this.maquinas.filter((maquina) => {
              return maquina.Desccliente.toLowerCase().indexOf(this.maquinaSearch.toLowerCase()) != -1;
            });

          }

          articulosSearchOld: string = ''
           filtroArticulos() {
            let search = this.articuloSearch
            if (this.articuloSearch.length < 3) search = '';
                let founds = this.articulos.filter((articulo) => 
                articulo.nombre.toLowerCase().indexOf(search.toLowerCase()) != -1);
                if (founds.length>0 ) {
                  //console.log('1')
                  //this.articuloActual = founds[0]
                  
                  if (this.articulosSearchOld !== search) {
                    //if (this.articuloActual !== founds[0]) {
                      this.articuloActual = founds[0];
                      //this.lotes.filter(l => l.idArticulo === founds[0].Id)
                      this.selArticulo(founds[0].Id);
                      this.articulosSearchOld = search
                    //}
                  }
                return founds
            } else {
                this.toastr.warning('Articulos no coinciden con filtro: ' + search,'Filtro')
                this.articuloSearch = '';
                this.lotes = [];
                this.selArticulo(this.articulos[0].Id);
                return this.articulos;
            }
         
            
         
          }

          filtroArticulos2() {
            return this.articulos.filter((articulo) => {
              return articulo.nombre.toLowerCase().indexOf(this.articuloSearch.toLowerCase()) != -1;
            });

          }


          descargarCargas() {
            this.http.loading = true;
                this.http.descargarCargas(this.fInicio, this.fFinal)
                        .subscribe(carga => {
                             this.cargas = carga;
                             this.http.loading = false;
                              console.log('Cargas: ', this.cargas)
                        }, err => {

                        }, () => {
                          if (this.cargas == null) {

                              this.toastr.warning("No existen cargas", "cargas");

                          }
                          //this.orden(2);
                          this.loaded = true;
                           ('completed');

                 });
              }

          descargarMaquinas() {
            this.http.loading = true;
            this.http.descargarMaquinas(0)
                    .subscribe(maquina => {
                         this.maquinas = maquina;
                         this.http.loading = false;
                    }, err => {

                    }, () => {

                    });
          }

          pulsado(carga) {
            this.http.loading = true;
            this.maquinaSearch = '';
            this.oldFecha = carga.fecha;
            this.Fecha = carga.fecha;
            this.oldMaquina = carga.Id;
            this.IdMaquina = carga.Id;
            this.crearNueva = false;
            this.titulocargas = 'Editando Carga ' + carga.maquina + ' - ' + carga.Cliente + ' (' + carga.Posicion + '(';
            this.http.cargaGrabar = this.http.nuevaCarga()

            this.http.descargarMaquinas(0)
                                .subscribe(maquina => {
                                     this.maquinas = maquina;
                                     this.selMaquina(this.IdMaquina)
                                     this.http.loading = false;
                                }, err => {
                                   (err.message);
                                }, () => {


                                    this.titulocargas = 'Editando Carga';
                                    this.mostrarDatosCargas = true;
                                    this.mostrarCargas = false;
                                    this.mostrarDatosLineas = false;


                                });


          }


          vercargas(carga) {

              this.maquinaSearch = '';

              this.IdMaquina = carga.Id;
              this.Fecha = carga.fecha;
              this.titulomostrarLineas = 'Editando Carga ' + carga.maquina + ' - ' + carga.Cliente + ' (' + carga.Posicion + ') Fecha: ' + carga.fecha;

              this.http.loading = true;
              this.http.descargarCargasMaquina(this.Fecha, this.IdMaquina).subscribe(respuesta => {
                this.http.loading = false;
                          this.mCargas =[];
                          this.mCargas = respuesta;
                          console.log("Cargas maquina mCargas: ", this.mCargas)

                        }, err => {

                        }, () => {

                            this.mostrarCargas = false;
                            this.mostrarLineas = true;



                          });



          }

          cancelarLinea() {
            this.mostrarCargas = true;
            this.mostrarLineas = false;

          }

          cancelarnuevaLinea(){
            this.http.loading = true;
            this.http.descargarCargasMaquina(this.Fecha, this.IdMaquina).subscribe(respuesta => {
              this.mCargas = respuesta;
              this.http.loading = false;
              this.mostrarDatosLineas = false;
              this.mostrarLineas = true;})
          }

          cancelarDatosCargas() {
            this.mostrarDatosCargas = false;
            this.mostrarCargas = true;

          }

          pulsadolinea(carga) {

              this.http.cargaGrabar = this.http.nuevaCarga();
              this.http.cargaGrabar.Id = carga.Id;
              this.http.cargaGrabar.fecha = this.Fecha;
              this.http.cargaGrabar.IdMaquina = this.IdMaquina;
              this.http.cargaGrabar.articulo = carga.articulo;
              this.http.cargaGrabar.Unidades =carga.Unidades;
              this.http.cargaGrabar.pc = carga.pc;
              this.http.cargaGrabar.pv = carga.pv;
              this.http.loading = true;
              this.http.descargarArticulosTarifa(this.IdMaquina)
                      .subscribe(articulo => {
                           this.articulos = articulo;
                      }, err => {
                         (err.message);
                      }, () => {
                           console.log("Articulos tarifaa: ", this.articulos)

                          this.titulolinea = 'Editando línea de Carga';
                          this.selArticuloWizard(this.articulos[0]);
                          this.articuloSearch = ''; 
                          this.http.loading = false;
                          this.mostrarDatosLineas = true;
                          this.mostrarLineas = false;
                         

                      });

          }

          tecla(n) {

            if (n === 'c') {
              this.valorTeclado = '0'
            } else if (n === 'x') {
              this.valorTeclado = '0';
              this.mostrarTeclado = false;
              this.mostrarTecladoArticulo = false;
              this.mostrarTecladoLote = false;
              this.mostrarTecladoCarga = false;
              this.esWizard = false;
            } else if (n === 'o') {
              this.http.cargaGrabar.Unidades = Number(this.valorTeclado)
              console.log(Number(this.valorTeclado))
              this.mostrarTeclado = false;
              if (this.esWizard) {
                this.mostrarTecladoCarga = true;
              }
            } else if (n === '.') {
              if (this.valorTeclado.indexOf('.') === -1)
              this.valorTeclado = this.valorTeclado + n;
            } else {
              if (this.valorTeclado === '0') this.valorTeclado = ''
              this.valorTeclado = this.valorTeclado + n;
            }
              
              console.log(n, this.valorTeclado)
          }

          nuevaLinea() {
            this.http.loading = true;
            this.valorTeclado = '0'
            this.http.loading = true;
            this.http.cargaGrabar = this.http.nuevaCarga()
            this.http.cargaGrabar.Id = 0;
            this.http.cargaGrabar.fecha = this.Fecha;
            this.http.cargaGrabar.IdMaquina = this.IdMaquina;
            this.lotes = [];
            this.articulos = []; 
            this.http.descargarArticulosTarifa(this.IdMaquina)
                    .subscribe(articulo => {
                        this.http.loading = false;
                        if (articulo.length > 0) {
                          this.articulos = articulo;
                          this.selArticuloWizard(this.articulos[0])
                          this.titulolinea = 'Creando nueva línea de Carga';
                          this.articuloSearch = '';
                          this.mostrarDatosLineas = true;
                          this.mostrarLineas = false;
                        } else {
                          this.toastr.error('La máquina no tiene tarifas asignadas', 'Error Tarifas')
                        }
                    }, err => {
                       (err.message);
                    }, () => {
                        console.log("Articulos Multiple: ", this.articulos)
                        
                        /*
                        let indice = 0;

                          this.articulos.forEach(articulo => {

                          let carga = this.mCargas.find( carga => carga.articulo == articulo.Id  );
                          console.log('C: ', carga);
                          if (carga ==null)
                          {

                            this.mCargas.push( new Carga('',
                             articulo.nombre, '0', this.IdMaquina, '', '', '0', articulo.Id,
                             this.Fecha, articulo.preciocompra, articulo.precioventa))
                          }

                        })
                        */
                         console.log("Carga Multiple: ", this.mCargas)
                         /*
                        this.http.cargaGrabar = this.http.nuevaCarga()
                        //this.http.cargaGrabar.articulo = this.articulos[0].Id;
                        this.http.cargaGrabar.Unidades = 0;
                        this.http.cargaGrabar.pc = this.articulos[0].preciocompra;
                        this.http.cargaGrabar.pv = this.articulos[0].precioventa;
                        */
                        
                        /*this.http.datosPost.action = 8;
                        this.http.datosPost.datos = null;
                        this.http.lotes(this.http.datosPost).subscribe( cargas => {
                          console.log('Cargas maquina: ', cargas)
                          this.titulolinea = 'Creando nueva línea de Carga';
                          this.articuloSearch = '';
                          this.mostrarDatosLineas = true;
                          this.mostrarLineas = false;
                        })*/
                       
                        

                    });

          }


          crearCarga() {
            this.http.loading = true;
           this.crearNueva = true;
           this.http.cargaGrabar = this.http.nuevaCarga();
           this.http.descargarMaquinas(0)
                   .subscribe(maquina => {
                        this.maquinas = maquina;
                        this.http.loading = false;
                   }, err => {

                   }, () => {
                      this.titulocargas = 'Crear Nueva Carga'
                      this.http.cargaGrabar.IdMaquina = this.maquinas[0].Id;
                      this.http.cargaGrabar.Fecha = this.hoy();
                      this.Fecha = this.hoy();
                      this.IdMaquina = this.maquinas[0].Id;
                      this.contadorActual = this.maquinas[0].contador
                      this.oldContador = this.contadorActual 
                      this.http.cargaGrabar.articulo = 1;
                      this.http.cargaGrabar.Unidades = 0;

                      this.mostrarDatosCargas = true;
                      this.mostrarCargas = false;

                  });
          }

          showConsumo() {
           try {
            let cont = Number(this.oldContador);
            
            let nuevo = Number(this.contadorActual);
            if (Number.isNaN(nuevo)) { 
              this.contadorActual = 0;
              nuevo = 0;
            }
            let dif = nuevo - cont;

            if (dif < 0) {
              return 'Error'
            } else
              return dif
           } catch(e) {
            return 'Error'
           }
          }

          actualizarRecaudacion(maquina, contador) {

            this.http.recaudacionGrabar = this.http.recaudacionVacia;
            this.http.recaudacionGrabar.IdMaquina = this.maquinaActual.Id;
            this.http.recaudacionGrabar.IdPosicion = this.maquinaActual.posicion;
            this.http.recaudacionGrabar.IdCliente = this.maquinaActual.Idcliente;
            this.http.recaudacionGrabar.Fecha = this.hoy();
            this.http.recaudacionGrabar.contador = this.contadorActual;
            
            this.http.datosPost.action = 1; // por defecto Update
            if (this.http.recaudacionGrabar.Id == 0) this.http.datosPost.action = 0; // si es nueva Insert;
            this.http.datosPost.datos = this.http.recaudacionGrabar;
        
            this.http.recaudacion(this.http.datosPost).subscribe(respuesta => {
              this.http.uploaded = respuesta;
        
            }, err => {
        
            }, () => {
              if (this.http.uploaded.Status == 1) {
                this.toastr.success('Creada Recaudacion asignada a la carga', 'Recaudacion');
              } else {
                this.toastr.error('Error al asignar Recaudacion a la carga', 'Recaudacion');
              }
            });
        
          }

          crearRecaudacion() {
            this.http.recaudacionGrabar = this.http.recaudacionVacia;
            this.http.recaudacionGrabar.IdMaquina = this.maquinaActual.Id;
            this.http.recaudacionGrabar.IdPosicion = this.maquinaActual.posicion;
            this.http.recaudacionGrabar.IdCliente = this.maquinaActual.Idcliente;
            this.http.recaudacionGrabar.Fecha = this.hoy();
            this.http.recaudacionGrabar.contador = this.contadorActual;
            
            this.http.datosPost.action = 1; // por defecto Update
            if (this.http.recaudacionGrabar.Id == 0) this.http.datosPost.action = 0; // si es nueva Insert;
            this.http.datosPost.datos = this.http.recaudacionGrabar;
            this.http.recaudacion(this.http.datosPost).subscribe(respuesta => {
              this.http.uploaded = respuesta;
        
            }, err => {
        
            }, () => {
              if (this.http.uploaded.Status == 1) {
                this.toastr.success('Creada Recaudacion asignada a la carga', 'Recaudacion');
              } else {
                this.toastr.error('Error al asignar Recaudacion a la carga', 'Recaudacion');
              }
            });
        
          }

          selMaquina(Id) {
            console.log(Id)
            this.IdMaquina = Id;
            let maquina = this.maquinas.find( m => m.Id === Id)
            this.contadorActual = maquina.contador;
            this.oldContador = this.contadorActual;
            console.log(Id, maquina, this.contadorActual)
            //this.contadorActual = 
          }

          selLote(lote) {
            this.http.loading = true;
            this.loteActual=lote; 
            this.mostrarTecladoLote=false
            let idLote = (<HTMLInputElement>document.getElementById('combolote'));
            idLote.value = this.loteActual.id;
            if (this.esWizard) {
              this.http.loading = false;
              this.mostrarTeclado = true;
            } else {
              this.http.loading = false;
            }

          }

          selLoteCombo(lote) {
            this.http.loading = true;
            this.loteActual=this.lotes.find(l => l.id === lote)
            this.mostrarTecladoLote=false
            //let idLote = (<HTMLInputElement>document.getElementById('combolote'));
            //idLote.value = this.loteActual.id;
            if (this.esWizard) {
              this.http.loading = false;
              this.mostrarTeclado = true;
            } else {
              this.http.loading = false;
            }

          }

          selArticulo(articulo) {
            this.http.loading = true;
            setTimeout(() => {
                console.log('2')
                this.articuloActual = this.articulos.find(a => a.Id === articulo)
                console.log('Articulo Actual: ', articulo, this.articuloActual)
                this.http.cargaGrabar.articulo = articulo;
                this.http.datosPost.action = 6;
                this.http.datosPost.datos = {
                  articulo: articulo
                }
                this.http.lotes(this.http.datosPost).subscribe( lotes => {
                  this.lotes = lotes;
                  if (this.lotes.length === 0) {
                    this.http.loading = false;
                    this.showRed = 1;
                    //this.toastr.error('No existen lotes. Cree lote para el articulo ' + this.articuloActual.nombre, 'Error Lote')
                  } else {
                    this.showRed = 0;
                  }
                 
                    this.loteActual = this.lotes[0];
                    this.http.loading = false;
                    console.log(lotes)
                    if (this.esWizard) {
                      if (this.lotes.length > 0)
                        this.mostrarTecladoLote = true
                      else
                        this.mostrarTeclado = true;
                    }
                
                })
              }, 100);
          }

          selArticuloWizard(articulo) {
           
            this.articuloActual = articulo
            this.http.cargaGrabar.articulo = articulo.Id;
            this.http.datosPost.action = 6;
            this.http.datosPost.datos = {
              articulo: articulo.Id
            }
            this.http.lotes(this.http.datosPost).subscribe( lotes => {
              this.lotes = lotes;
              if (this.lotes.length === 0) {
                this.http.loading = false;
                this.showRed = 1;
                //this.toastr.error('No existen lotes. Cree lote para el articulo ' + this.articuloActual.nombre, 'Error Lote')
              } else {
                this.showRed = 0;
              }
                this.loteActual = this.lotes[0];
                console.log(lotes)
                this.http.loading = false;
                if (this.esWizard) {
                  if (this.lotes.length > 0)
                     this.mostrarTecladoLote = true
                  else
                     this.mostrarTeclado = true;
                }
            
            })
          }

          volver() {
            this.http.sw.mostrarDatosmaquinas = true;
            this.toastr.warning("Cargando Datos...", "Internet");
          }

          cancelar() {

              this.mostrarDatosCargas = false;
              this.mostrarCargas = true;

          }

          borrarcargatotal(carga) {

            this.http.cargaGrabar = this.http.nuevaCarga();
            this.http.cargaGrabar.Id = 0;
            this.http.cargaGrabar.fecha = carga.fecha
            this.http.cargaGrabar.IdMaquina = carga.Id;
          }

          borrarlinea(carga) {
            this.idLote = carga.idLote;
            this.http.cargaGrabar = this.http.nuevaCarga();
            this.http.cargaGrabar = carga;
          }

          borrar(){
            this.http.loading = true;
            if (this.http.cargaGrabar.Id == 0 ) { // borrar todos las cargas

                  this.http.datosPost.action = 4; // borrar
                  this.http.datosPost.datos = this.http.cargaGrabar;
                  this.http.cargas(this.http.datosPost).subscribe(respuesta => {
                        this.http.uploaded = respuesta;

                    }, err => {

                    }, () => {
                        if (this.http.uploaded.Status == 1) {
                              this.toastr.success(this.http.uploaded.Text,'Cargas');
                              this.http.descargarCargas(this.fInicio, this.fFinal).subscribe(respuesta => {
                                this.cargas =respuesta;
                                this.http.loading = false;
                            });
                        }else{
                          this.http.loading = false;
                            this.toastr.error(this.http.uploaded.Text,'Cargas');
                        }
                  });
              }else{

                      this.http.datosPost.action = 2; // borrar
                      this.http.datosPost.datos = this.http.cargaGrabar;
                      this.http.cargas(this.http.datosPost).subscribe(respuesta => {
                            this.http.uploaded = respuesta;

                        }, err => {
                          this.http.loading = false;
                             (err.message);
                        }, () => {
                            if (this.http.uploaded.Status == 1) {
                                  this.toastr.success(this.http.uploaded.Text,'Linea Cargas');
                                  this.http.descargarCargasMaquina(this.http.cargaGrabar.fecha, this.http.cargaGrabar.IdMaquina).subscribe(respuesta => {
                                    this.mCargas =respuesta;
                                    this.http.datosPost.action = 9;
                                    this.http.datosPost.datos = {
                                      lote: this.idLote,
                                      count: Number(this.http.cargaGrabar.Unidades)
                                    }
                                    this.http.lotes(this.http.datosPost).subscribe( lotes => {
                                      console.log('Stock lotes: ', lotes)
                                      this.selArticuloWizard(this.articuloActual)
                                    })
                                    this.http.loading = false;
                                });
                            }else{

                                this.toastr.error(this.http.uploaded.Text,'Linea Cargas');
                            }
                      });

              }
          }

          logOut() {
            this.http.sw.mostrarLogin = true;
            this.http.sw.mostrarMenu = false;
            this.http.sw.mostrarCargasOperador = false;
          };

          actualizarContadorMaquina(contador, id) {
            console.log('Recido contador: ', contador, id)
            this.http.actualizarContador(contador, id).subscribe(respuesta => {
                    this.http.uploaded = respuesta;
                }, err => {
                }, () => {
                    if (this.http.uploaded.Status == 1) {
                        this.toastr.success('Actualizado contador','Contador');
                    }else{
                        this.toastr.error('Error actualizar contador','Contador');
                    }
              });
            }
          

          grabar() {

            this.http.loading = true;
              let id = (<HTMLInputElement>document.getElementById('combo')).value;
              let maquinaactual  = this.maquinas.find(maquina => maquina.Id ===  id )
              this.maquinaActual = maquinaactual;
              this.http.datosPost.action = 0;
              this.http.cargaGrabar.IdMaquina = maquinaactual.Id;
              this.http.cargaGrabar.fecha = this.Fecha;
              this.http.cargaGrabar.hora = new Date().toTimeString();
              if (!this.crearNueva) {
                  this.http.cargaGrabar.oldFecha = this.oldFecha;
                  this.http.cargaGrabar.oldMaquina = this.oldMaquina
                  this.http.datosPost.action = 3; //actualizar fecha y maquina

              }
                  let date = new Date();
                  var minutes = date.getMinutes();  
                  var hours = date.getHours();
                  this.http.cargaGrabar.hora = new Date().toLocaleTimeString();
                  this.http.datosPost.datos = this.http.cargaGrabar;
                  this.http.datosPost.datos.lote = 0;
                  this.http.cargas(this.http.datosPost).subscribe(respuesta => {
                      this.http.uploaded = respuesta;

                      }, err => {

                      }, () => {
                      if (this.http.uploaded.Status == 1) {
                            if (this.showConsumo() !== 'Error') {
                              this.actualizarContadorMaquina(this.contadorActual, maquinaactual.Id)
                            } else {
                              this.toastr.warning('No se ha actualizado el contador','Carga');
                            }
                            if (this.crearNueva) {
                              this.crearRecaudacion();
                            } else {
                              //this.actualizarRecaudacion(this.maquinaActual, this.Fecha);
                            }
                            this.toastr.success(this.http.uploaded.Text,'Carga');
                            this.http.descargarCargas(this.fInicio, this.fFinal).subscribe(respuesta => {
                            this.cargas = respuesta;
                            this.mostrarDatosCargas = false;
                            this.mostrarCargas = true;
                            this.http.loading = false;
                           
                          });
                      }else{
                        this.http.loading = false;
                            this.toastr.error(this.http.uploaded.Text,'Carga');
                      }
                    });
                 

            }

            grabarlineaold() {

              this.mCargas.Borrar = this.IdMaquina;
              this.mCargas.FechaBorrar = this.Fecha;
              console.log('Grabar Multiple: ', this.mCargas)
/*
              let id = (<HTMLInputElement>document.getElementById('comboarticulo')).value
              let articuloactual  = this.articulos.find(articulo => articulo.Id ===  id );

              this.http.cargaGrabar.IdMaquina = this.IdMaquina;
              this.http.cargaGrabar.fecha = this.Fecha;
              this.http.cargaGrabar.oldFecha = this.oldFecha;
              this.http.cargaGrabar.oldMaquina = this.oldMaquina;
              this.http.cargaGrabar.articulo = articuloactual.Id;
              this.http.cargaGrabar.pc = articuloactual.preciocompra;
              this.http.cargaGrabar.pv = articuloactual.precioventa;

              if (this.http.cargaGrabar.Id == 0) {
                  this.http.datosPost.action = 0; // insertar Carga
              }else{
                  this.http.datosPost.action = 1; // actualizar Carga
              }

              */


              this.http.datosPost.action = 5;
              this.http.datosPost.datos = this.mCargas  //this.http.cargaGrabar;
              console.log('Post: ', this.http.datosPost)
              this.http.cargas(this.http.datosPost).subscribe(respuesta => {
                  this.http.uploaded = respuesta;

                  }, err => {
                   (err.message);
                  }, () => {

                    console.log('Respuesta: ', this.http.uploaded)
                  if (this.http.uploaded.Status == 1) {
                        this.toastr.success(this.http.uploaded.Text,'Carga');
                        this.http.descargarCargasMaquina(this.Fecha, this.IdMaquina).subscribe(respuesta => {
                        this.mCargas = respuesta;
                        this.mostrarDatosLineas = false;
                        this.mostrarLineas = true;
                      });
                  }else{
                        this.toastr.error(this.http.uploaded.Text,'Carga');
                  }
                });

            }

            grabarlinea() {
              this.mostrarTecladoCarga = false;
              this.esWizard = false;
              if (this.http.cargaGrabar.Unidades > 0) {
                this.http.loading = true;
              //let art:any = (<HTMLInputElement>document.getElementById('comboarticulo')).value
              //let articuloactual  = this.articulos.find(articulo => articulo.Id ===  art.Id );

              //let idLote = (<HTMLInputElement>document.getElementById('combolote')).value;
              //this.loteActual  = this.lotes.find(lote => lote.id ===  idLote )
                console.log('4')
                let articuloactual = this.articuloActual;
                this.http.cargaGrabar.IdMaquina = this.IdMaquina;
                this.http.cargaGrabar.fecha = this.Fecha;
                this.http.cargaGrabar.oldFecha = this.oldFecha;
                this.http.cargaGrabar.oldMaquina = this.oldMaquina;
                this.http.cargaGrabar.articulo = articuloactual.Id;
                this.http.cargaGrabar.pc = articuloactual.preciocompra;
                this.http.cargaGrabar.pv = articuloactual.precioventa;
                this.http.cargaGrabar.lote = this.loteActual ? this.loteActual.id : 1;
                this.http.datosPost.action = 0;
                this.http.datosPost.datos = this.http.cargaGrabar  //this.http.cargaGrabar;
                let grabar = false;
                if (this.http.cargaGrabar.lote == 1) grabar = true;
                console.log(this.loteActual)
                if (this.loteActual)  
                  if (Number(this.loteActual.stock) >= Number(this.http.cargaGrabar.Unidades)) 
                     grabar = true
                  else 
                     grabar = false;
                if (grabar) {
                  this.http.cargas(this.http.datosPost).subscribe(respuesta => {
                  this.http.uploaded = respuesta;
                  console.log('Carga grabada: ', respuesta)
                  }, err => {
                    this.http.loading = false;
                   (err.message);
                  }, () => {
                    
                    console.log('Respuesta: ', this.http.uploaded)
                  if (this.http.uploaded.Status == 1) {
                        this.toastr.success(this.http.uploaded.Text,'Carga');
                        this.http.descargarCargasMaquina(this.Fecha, this.IdMaquina).subscribe(respuesta => {
                        this.mCargas = respuesta;
                        //this.mostrarDatosLineas = false;
                        //this.mostrarLineas = true;
                        if (this.loteActual) {
                          this.http.datosPost.action = 9;
                          this.http.datosPost.datos = {
                            lote: this.loteActual.id,
                            count: - Number(this.http.cargaGrabar.Unidades)
                          }
                          console.log(this.http.datosPost)
                          this.http.lotes(this.http.datosPost).subscribe( lote => {
                            console.log(lote);
                            this.selArticuloWizard(this.articulos[0])
                            this.http.cargaGrabar.Unidades = '';
                            this.articuloSearch = '';
                            document.getElementById('search').focus()
                            this.http.loading = false;
                          })
                        } else {
                          this.selArticuloWizard(this.articulos[0])
                          this.http.cargaGrabar.Unidades = '';
                          this.articuloSearch = '';
                          document.getElementById('search').focus()
                        } 
                      });
                  }else{
                      this.http.loading = false;
                      this.toastr.error(this.http.uploaded.Text,'Carga');
                  }
                  });
                } else {
                  this.http.loading = false;
                  this.toastr.error('No hay suficiente Stock', 'Stock Error')
                }

            
             } else {
              this.http.loading = false;
              this.toastr.error('Las unidades a cargar deben ser mayor que 0', 'Carga errónea')
            }
          }
}




// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/cargas-operador/cargas-operador.component.ts